<div *ngIf="config" class="lifemap-questions relative w-full">
  <div
    class="absolute left-2 top-3 z-10 flex cursor-pointer select-none items-center justify-center"
    (click)="onPrevButtonClicked()"
    [ngClass]="{
      'pointer-events-none opacity-50': disablePrevSlideButton()
    }"
  >
    <pl-icon
      [name]="PlIcon.chevron_back"
      [frame]="IconFrame.round"
      class="h-10 w-10 border-transparent bg-pl-gray-300 text-pl-gray-700 hover:bg-gray-400"
    />
  </div>
  <swiper-container
    plSwiper
    [config]="config"
    init="false"
    class="relative flex w-full rounded-md bg-pl-gray-100 shadow-md"
    [ngClass]="{
      'border-2 border-pl-error': controlDir.control?.errors && controlDir.control?.dirty && isFormSubmitted
    }"
  >
    <swiper-slide class="" *ngFor="let singleQuestion of questions(); let index = index">
      <pl-single-question
        [question]="singleQuestion"
        [questionNumber]="index + 1"
        [totalNumberQuestions]="questions().length"
        [(ngModel)]="answers[index]"
        (ngModelChange)="onQuestionAnswered(index)"
      />
    </swiper-slide>
  </swiper-container>
  <div
    class="absolute right-2 top-3 z-10 flex cursor-pointer select-none items-center justify-center"
    [ngClass]="{
      'pointer-events-none opacity-50': disableNextSlideButton()
    }"
    (click)="onNextButtonClicked()"
  >
    <pl-icon
      [name]="PlIcon.chevron_forward"
      [frame]="IconFrame.round"
      class="h-10 w-10 border-transparent bg-pl-gray-300 text-pl-gray-700 hover:bg-gray-400"
    />
  </div>
</div>
<div
  *ngIf="controlDir.control?.errors && controlDir?.control?.dirty && isFormSubmitted"
  class="pt-1 text-xs italic text-pl-error"
>
  <span *ngIf="controlDir.control?.errors?.[CustomErrorsLifemapQuestions.notAllQuestionsAnswered]">
    {{
      'lifemap.errors.question_not_answered'
        | translate
          : { questionNumber: controlDir.control?.errors?.[CustomErrorsLifemapQuestions.notAllQuestionsAnswered] }
    }}
  </span>
</div>
